import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import { isAuthenticated } from 'modules/auth/selectors'
import { HOME_PATH } from 'config'


const AnonRoute = ({ isAuthenticated, component, ...rest }) => {
  return (
    <Route
      { ...rest }
      render={ props => {
        return isAuthenticated ?
          <Redirect to={ HOME_PATH } /> :
          React.createElement(component, props)
      } }
    />
  )
}

AnonRoute.propTypes = {
  component: PropTypes.func,
  isAuthenticated: PropTypes.bool.isRequired,
}

export default connect(state => ({ isAuthenticated: isAuthenticated(state) }))(AnonRoute)



// WEBPACK FOOTER //
// ./src/components/app/anon-route.js